import request from "arcdynamic-request";

// read
export function getData({tableCode, options}) {
    return request(arc.path.api, {
        service: 'arcimedes',
        action: 'open.datasource.table.Data.getData',
        params: ['code', tableCode, options]
    });
}

// create, update, delete
export function manageData({tableCode, data}) {
    return request(arc.path.api, {
        service: 'arcimedes',
        action: 'open.datasource.table.Data.updateByTableCode',
        params: [tableCode, {
            value: data, // data has to be array
        }]
    });
}